import thunk from 'redux-thunk';
import { applyMiddleware, compose, createStore } from 'redux';
import reducer from './reducer';
import { createLogger } from 'redux-logger';

const loggerMiddleware = createLogger({
  diff: true,
});

export function configureStore() {
  //const enhancer = compose(applyMiddleware(thunk, loggerMiddleware));
  // const devTools =  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
  const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const enhancer = composeEnhancer(applyMiddleware(thunk));

  return createStore(reducer, enhancer);
}
export const store = configureStore({});
